import CookieService from 'utils/miscUtils/CookieService';

const OTCookieName = 'OptanonConsent';

export const findOnetrustCookieOptInAds = () => {
  const oneTrust = CookieService.get(OTCookieName);
  return !!(oneTrust && oneTrust.includes('C0004:1') && oneTrust.includes('C0005:1'));
};

export const findOnetrustCookiePerformance = () => {
  const oneTrust = CookieService.get(OTCookieName);
  return !!(oneTrust && oneTrust.includes('C0002:1') && oneTrust.includes('C0003:1'));
};

const findOnetrustCookieOptIn = () => {
  const oneTrust = CookieService.get(OTCookieName);
  return !!(oneTrust && oneTrust.includes('C0001:1'));
};

export default findOnetrustCookieOptIn;
